import { Component, computed, input, linkedSignal, output, WritableSignal } from '@angular/core';
import { TaskPriority } from '@app/shared/types/enums/task-priority.enum';
import { UiPriorityBadgeComponent } from '@app/shared/ui/priority-badge/ui-priority-badge.component';
import { UiSelectComponent } from '@app/shared/ui/select/ui-select.component';
import { PROFFEO_TASK_PRIORITY_TOKENS } from '@app/shared/ui/tokens/task-priority.tokens';
import { ProffeoUiSelectOption } from '@app/shared/ui/types/select.types';
import { ProffeoUiDensity } from '@app/shared/ui/types/ui.types';

@Component({
  selector: 'proffeo-task-priority-select',
  imports: [UiSelectComponent, UiPriorityBadgeComponent],
  templateUrl: './task-priority-select.component.html'
})
export class TaskPrioritySelectComponent {
  protected readonly priorityOptions: ProffeoUiSelectOption<TaskPriority>[] = [
    TaskPriority.NORMAL,
    TaskPriority.MEDIUM,
    TaskPriority.HIGH
  ].map(priority => ({
    value: priority,
    label: PROFFEO_TASK_PRIORITY_TOKENS[priority].translationKey
  }));

  protected readonly selectedPriority: WritableSignal<TaskPriority> = linkedSignal(() => this.taskPriority());

  protected readonly badgeDensity = computed((): ProffeoUiDensity => (this.small() ? 'compact' : 'comfortable'));

  public readonly prioritySelected = output<TaskPriority>();
  public readonly taskPriority = input.required<TaskPriority>();
  public readonly readonly = input<boolean>(true);
  public readonly small = input<boolean>(true);

  protected onPriorityChange(priority: TaskPriority | TaskPriority[] | null): void {
    if (priority === null || Array.isArray(priority) || priority === this.selectedPriority()) {
      return;
    }

    this.selectedPriority.set(priority);
    this.prioritySelected.emit(priority);
  }
}
